import { render, staticRenderFns } from "./PlanMoreDrawer.vue?vue&type=template&id=04995102&scoped=true"
import script from "./PlanMoreDrawer.vue?vue&type=script&lang=js"
export * from "./PlanMoreDrawer.vue?vue&type=script&lang=js"
import style0 from "./PlanMoreDrawer.vue?vue&type=style&index=0&id=04995102&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04995102",
  null
  
)

export default component.exports